/* One delegated header controller, including editor replacement and page restore. */
(() => {
  if (window.titanHeaderBound) return;
  window.titanHeaderBound = true;
  const ROOT = '[data-titan-header]';
  const OPEN = '.open-submenu, .open-submenu-grand';
  const TRIGGER = '[data-header-submenu-trigger]';
  const desktop = matchMedia('(min-width: 768px)');
  const triggerOf = item => item.querySelector(':scope > ' + TRIGGER);
  const panelOf = item => item.querySelector(':scope > ul');
  const isOpen = item => triggerOf(item)?.getAttribute('aria-expanded') === 'true';

  function fitPanel(item) {
    const panel = panelOf(item);
    if (!panel?.classList.contains('desktop-submenu')) return;
    panel.style.setProperty('--header-submenu-nudge', '0px');
    const rect = panel.getBoundingClientRect();
    const shift = Math.max(16 - rect.left, Math.min(0, innerWidth - 16 - rect.right));
    panel.style.setProperty('--header-submenu-nudge', `${shift}px`);
  }

  function setOpen(item, open) {
    item.classList.toggle(item.matches('.desktop-has-submenu-grand') ? 'open-submenu-grand' : 'open-submenu', open);
    triggerOf(item)?.setAttribute('aria-expanded', String(open));
  }
  function closeWithin(scope) {
    scope.querySelectorAll(OPEN).forEach(item => setOpen(item, false));
  }
  function closeAll() {
    document.querySelectorAll(ROOT).forEach(closeWithin);
  }
  function open(item) {
    // A grandchild closes its siblings, while retaining its parent panel.
    closeWithin(item.parentElement);
    setOpen(item, true);
    fitPanel(item);
  }
  function controls(panel) {
    return Array.from(panel.querySelectorAll(':scope > li > a[href]'));
  }
  function closeBranch(item) {
    closeWithin(item);
    setOpen(item, false);
    triggerOf(item)?.focus({ preventScroll: true });
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const root = event.target.closest(ROOT);
    const checkout = root && event.target.closest('[data-header-checkout]');
    if (checkout && window.ThemeCart) {
      event.preventDefault();
      window.ThemeCart.checkout(checkout).catch(() => window.location.assign(checkout.href));
      return;
    }
    const trigger = root && event.target.closest(TRIGGER);
    if (!trigger || !desktop.matches) { closeAll(); return; }
    event.preventDefault();
    const item = trigger.parentElement;
    if (isOpen(item)) { closeWithin(item); setOpen(item, false); }
    else open(item);
  });

  document.addEventListener('keydown', event => {
    if (!(event.target instanceof Element) || event.defaultPrevented || !desktop.matches) return;
    const root = event.target.closest(ROOT);
    if (!root || event.target.closest('[data-header-search]')) return;
    const trigger = event.target.closest(TRIGGER);
    const panel = event.target.closest('.desktop-submenu, .desktop-submenu-grand');
    if (trigger && (event.key === 'ArrowDown' || event.key === ' ')) {
      event.preventDefault(); open(trigger.parentElement);
      controls(panelOf(trigger.parentElement))[0]?.focus({ preventScroll: true });
      return;
    }
    if (event.key === 'Escape') {
      const item = trigger && isOpen(trigger.parentElement) ? trigger.parentElement : panel?.parentElement;
      if (!item) return;
      event.preventDefault(); event.stopPropagation(); closeBranch(item);
      return;
    }
    if (!panel || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
    const items = controls(panel);
    if (!items.length) return;
    event.preventDefault();
    const current = items.indexOf(event.target.closest('a'));
    const index = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (current + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
    items[index].focus({ preventScroll: true });
  });

  document.addEventListener('focusin', event => {
    // Moving to another header control closes the branch left behind.
    document.querySelectorAll(ROOT).forEach(root => root.querySelectorAll(OPEN).forEach(item => {
      if (!item.contains(event.target)) { closeWithin(item); setOpen(item, false); }
    }));
  });
  document.addEventListener('theme:close-navigation', closeAll);
  document.addEventListener('shopify:section:load', closeAll);
  document.addEventListener('shopify:section:unload', closeAll);
  desktop.addEventListener('change', closeAll);
  window.addEventListener('resize', () => {
    document.querySelectorAll(`${ROOT} .open-submenu`).forEach(fitPanel);
  }, { passive: true });
  window.addEventListener('pageshow', closeAll);
})();
